import Vue from 'vue'
import { vinculos as routing } from '../util/routes'

export default {
  state: {
    vinculos: [],
    vinculo: {},
    competencia: null,
    desligado: false
  },
  mutations: {
    setVinculos: (state, payload) => {
      state.vinculos = payload
    },
    setVinculo: (state, payload) => {
      state.vinculo = payload
    },
    setCompetencia: (state, payload) => {
      state.competencia = payload
    },
    setDesligado: (state, payload) => {
      state.desligado = payload
    }
  },
  actions: {
    async getVinculos ({ commit }, { industria }) {
      commit('setVinculos', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        params: {
          industria
        }
      })
      return commit('setVinculos', data)
    },
    async postRefreshVinculos ({ commit }, { industria }) {
      return Vue.axios.post(`${routing}/refresh`, {
        industria
      })
    },
    async getVinculo ({ commit }, { id }) {
      commit('setVinculo', {})
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      return commit('setVinculo', data)
    },
    async putSaveCadastramento ({ state }) {
      const { vinculo } = state
      return Vue.axios.put(`${routing}/cadastramento/${vinculo.cadastramento.id}`, {
        ...vinculo.cadastramento
      })
    },
    async putSavePrimeiraFase ({ state }) {
      const { vinculo } = state
      return Vue.axios.put(`${routing}/primeira/${vinculo.primeiraFase.id}`, {
        ...vinculo.primeiraFase
      })
    },
    async putSaveSegundaFase ({ state }) {
      const { vinculo } = state
      return Vue.axios.put(`${routing}/segunda/${vinculo.segundaFase.id}`, {
        ...vinculo.segundaFase
      })
    },
    async putSaveTerceiraFase ({ state }) {
      const { vinculo } = state
      return Vue.axios.put(`${routing}/terceira/${vinculo.terceiraFase.id}`, {
        ...vinculo.terceiraFase
      })
    }
  },
  getters: {
    vinculos: ({ vinculos }) => vinculos,
    vinculo: ({ vinculo }) => vinculo,
    desligado: ({ desligado }) => desligado,
    competencia: ({ competencia }, commit) => {
      if (!competencia) competencia = Vue.options.filters.actualJurisdiction()
      return competencia
    }
  }
}
